<div class="df">
  <div class="df-body" [class.collapsed]="df.collapsed">
    <df-sidebar></df-sidebar>

    <div class="df-main" tabindex="-1">
      <div class="wrap">
        <ng-container *ngIf="df.view === 'search'; else infoPage">
          <div class="page-h">
            <h2>Lift & Fit Explore agent</h2>
            <p>Create an Explore Design deck for Lift & Fit scenarios using your selected ECC process flows and supporting source documents.</p>
          </div>

          <df-stepper (stepSelected)="onStepSelected($event)"></df-stepper>
          <df-scope-chips *ngIf="df.step > 1"></df-scope-chips>

          <ng-container [ngSwitch]="df.step">
            <df-ask-step *ngSwitchCase="1"></df-ask-step>
            <df-retrieve-step *ngSwitchCase="2"></df-retrieve-step>
            <df-review-step *ngSwitchCase="3"></df-review-step>
            <df-feedback-step *ngSwitchCase="4"></df-feedback-step>
            <df-publish-step *ngSwitchCase="5"></df-publish-step>
            <df-pbl-step *ngSwitchCase="6"></df-pbl-step>
            <df-deck-step *ngSwitchCase="7"></df-deck-step>
          </ng-container>
        </ng-container>

        <ng-template #infoPage><df-info-pages></df-info-pages></ng-template>
      </div>

      <df-action-bar></df-action-bar>
    </div>
  </div>

  <div class="scrim" [class.on]="df.overlayOpen" (click)="closeOverlays()"></div>
  <df-doc-drawer></df-doc-drawer>
  <df-exclude-modal *ngIf="df.excludeIds"></df-exclude-modal>
  <df-missing-modal *ngIf="df.missingModal.open"></df-missing-modal>
  <div class="toast" [class.on]="df.toastVisible" role="status" aria-live="polite">{{ df.toastMessage }}</div>
</div>
